import { render, staticRenderFns } from "./SearchFile.vue?vue&type=template&id=847b2848&"
import script from "./SearchFile.vue?vue&type=script&lang=js&"
export * from "./SearchFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports